import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './rootReducers'
// (process.env.NODE_ENV === "development" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose
const middleWare = [thunk.withExtraArgument()]
const store = createStore(rootReducer, compose(applyMiddleware(...middleWare)))

export default store
